import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "../../../util/asyncComponent";

const Smartfolio = ({ match }) => {
  return (
    <div className="app-wrapper">
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/overall`} />
        <Route
          path={`${match.url}/overall`}
          component={asyncComponent(() => import("./routes/Overall"))}
        />
        <Route
          path={`${match.url}/performance-detail`}
          component={asyncComponent(() => import("./routes/designer"))}
        />
        <Route
          component={asyncComponent(() =>
            import("app/routes/extraPages/routes/404")
          )}
        />
      </Switch>
    </div>
  );
};

export default Smartfolio;
